import * as React from 'react';

function MyBetsPlaced(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <rect width={24} height={24} rx={4} fill="#00599E" />
      <path
        d="M4.5 12.75L9.75 18 19.5 5.25"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default MyBetsPlaced;
